import { render, staticRenderFns } from "./SkillTraining.vue?vue&type=template&id=728a81f1&scoped=true"
import script from "./SkillTraining.vue?vue&type=script&lang=js"
export * from "./SkillTraining.vue?vue&type=script&lang=js"
import style0 from "./SkillTraining.vue?vue&type=style&index=0&id=728a81f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a81f1",
  null
  
)

export default component.exports